import {Injectable} from '@angular/core';
import {Events} from 'ionic-angular';
import {map} from 'rxjs/operators/map';
import {Observable} from "rxjs/Observable";
import {ApiProvider} from "./api/api";
import {ClienteModel} from "../model/cliente.model";
import {UserInfo} from "firebase";

export class ChatMessage {
  userId: number;
  clienteId: number;
  userName: string;
  left: boolean;
  dataHora: string;
  message: string;
}

@Injectable()
export class ChatService {

  constructor(
    private events: Events,
    private api: ApiProvider) {
  }

  sendMsg(msg: ChatMessage) {
    return new Promise(resolve => {
      this.api.post('CLIENTEMESSAGE', {message: msg}).then((data: any) => {
        resolve();
      });
    });
  }

  getMsgList() {

  }

}



// WEBPACK FOOTER //
// ./src/providers/chat-service.ts